export default __webpack_public_path__ + "static/media/icon-drop_down_disabled.9a732969.svg";